/**
 * Local calendar dates.
 *
 * WHY THIS FILE EXISTS
 *
 * `new Date().toISOString().slice(0, 10)` was used in six places to mean
 * "today". It does not mean today; it means today in UTC. Riyadh is
 * UTC+3, so between midnight and 03:00 local it returns YESTERDAY.
 *
 * In a transport office that is not a corner case. Slips get keyed after
 * the last truck is back, and a voucher silently dated the previous day
 * lands in a period that may already be reconciled.
 *
 * The month-start version was worse and visible: `new Date(y, m, 1)` is
 * local midnight on the 1st, which converted to UTC is 21:00 on the last
 * day of the PREVIOUS month -- so an invoicing screen opened in October
 * offered a window starting 30 September.
 *
 * These build the string from the local calendar fields directly, so
 * there is no conversion to get wrong.
 */

const pad = (n: number) => String(n).padStart(2, '0')

/** yyyy-mm-dd for a Date, read off the LOCAL calendar. */
export function isoDate(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

/** Today, where the user is. */
export function today(): string {
  return isoDate(new Date())
}

/** The first of the current month, where the user is. */
export function monthStart(): string {
  const d = new Date()
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-01`
}

/** The first of the month `back` months ago. */
export function monthStartAgo(back: number): string {
  const d = new Date()
  d.setDate(1)
  d.setMonth(d.getMonth() - back)
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-01`
}
